import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import { SsStepper } from '@bit/ui-common.ui-components/ss-components';
import { Icon } from 'antd';
import { Row, Col, Card } from 'antd';
import Welcome from '../registration/candidate/Recovery';
import Personal from '../registration/candidate/RecoverPersonal';
import Passport from '../registration/candidate/RecoverPassport';
import IdAndEmail from '../registration/candidate/RecoverEmail';
import Signature from '../registration/candidate/RecoverSignature';
import Submit from '../registration/candidate/RecoverySubmit';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
    { SsStepperLayout, SsStep } = SsStepper,
    { setEnvPrefix } = ssCommonUtils,
    imagesPath = '/home/images',
    afspLayout = {
        bgc: '#e6e6e6',
        controlType: 'home',
        size: { header: 'xs', footer: 'xs' },
        images: {
            usePathname: false,
            logo: setEnvPrefix(`${imagesPath}/dhs-logo-01.png`),
            user: setEnvPrefix(`${imagesPath}/user-icon-01.png`),
        }
    };

export default class CandidateAccountRecoveryLayout extends React.Component {
    constructor(props) {
        super(props);
        this.common = { utils: { updateTitle: this.updateTitle } };
    }

    updateTitle(stepNumber, icon, service, prevStatus, currStatus) {
        const
            title = s => (<div><Icon type={s} />{` Step ${stepNumber}`}</div>);
        if (prevStatus === 'invalid' && currStatus === 'valid') service(title('check-circle-o'));
        else if (prevStatus === 'valid' && currStatus === 'invalid') service(title(icon));
    }

    render() {
        const
            { services, candidateRecovery } = this.props,
            stepperLayout = {
                id: 'candidate-recovery',
                state: candidateRecovery,
                services: services
            };

        return (
            <div>
                <AfspLayout {...afspLayout}>
                    <SsStepperLayout {...stepperLayout} header={
                        <div>
                            <Row type='flex' justify='space-around' align='middle' style={{ margin: '15px 0 15px 0' }}>
                                <Col span={23} style={{ fontWeight: 'bold', fontSize: '24px' }}>
                                    <Card bodyStyle={{ padding: '10px', textAlign: 'center' }}>
                                        <span style={{ color: 'rgb(53, 158, 255)' }}>
                                            {'Candidate'}
                                        </span>
                                        {' Account Recovery Request'}
                                    </Card>
                                </Col>
                            </Row>
                        </div>}
                        progressDot>
                        <SsStep
                            id='Welcome'
                            description='Welcome'
                            title={(<div><Icon id='candidate-recovery-welcome' type='home' style={{ marginRight: '6px' }} /></div>)}
                            render={() => <Welcome {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='Personal'
                            description='Enter Personal Information'
                            title={(<div><Icon type='user' id='candidate-recovery-personal-info' style={{ marginRight: '6px' }} />{'Step 1'}</div>)}
                            render={() => <Personal {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='Passport'
                            description='Enter Passport Information'
                            title={(<div><Icon type='idcard' id='candidate-recovery-passport' style={{ marginRight: '6px' }} />{'Step 2'}</div>)}
                            render={() => <Passport {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='Email'
                            description='Enter User ID and Email'
                            title={(<div><Icon type='mail' id='candidate-recovery-user-id' style={{ marginRight: '6px' }} />{'Step 3'}</div>)}
                            render={() => <IdAndEmail {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='signature'
                            description='Verify / Digitally Sign'
                            title={(<div><Icon type='edit' id='candidate-recovery-signature' style={{ marginRight: '6px' }} />{'Step 4'}</div>)}
                            render={() => <Signature {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='submit'
                            description='Submit Recovery Request'
                            title={(<div><Icon type='login' id='candidate-recovery-submit' style={{ marginRight: '6px' }} />{'Step 5'}</div>)}
                            render={() => <Submit {...this.common} {...this.props} />}
                            fullState
                        />
                    </SsStepperLayout>
                </AfspLayout>
            </div>
        )
    }
}
